import defer from './defer';

export function requestIdleCallbackPollyfill(callback) {
	defer(function requestIdleCallbackPollyfillTimeout() {
		const start = Date.now();
		const maxBusy = 100;
		callback({
			didTimeout: false,
			timeRemaining() {
				return Math.max(0, maxBusy - (Date.now() - start));
			}
		});
	});
}

/**
 * This method queues a function to be called during a browser's idle periods
 * @example
 * requestIdleCallback(() => {})
 *
 * @function requestIdleCallback
 * @param {Function} callback The callback function to execute
 * @return {Object} undefined
 */
const requestIdleCallback = window.requestIdleCallback || requestIdleCallbackPollyfill;

/*
Chromium based browsers have a bug in which Iframes and rIC do not work well together.

See -

https://bugs.chromium.org/p/chromium/issues/detail?id=1240307
https://bugs.chromium.org/p/chromium/issues/detail?id=1240317

so when we see an Iframe on Chromium, we force rIC to be called every X milliseconds to
ensure the tasks are run.

DO NOT MOVE THIS TO A UTILS FILE, we want to get rid of this logic ASAP rather than reuse it
elsewhere
*/
const isChromium = window?.navigator?.userAgentData?.brands?.some(b => b.brand === 'Chromium');
const isIframe = window?.location !== window?.parent?.location;

const rIC = isChromium && isIframe ? requestIdleCallbackPollyfill : requestIdleCallback;

export default rIC;
